<ul class="booking-info-list">
  <ng-content select="ui-booking-info-list-item"></ng-content>
</ul>
